// Должен соответствовать projectName
/* istanbul ignore next */
export const UNIQUE_CONFIG_KEY = 'newbuilding-promos-frontend';

export const NEWBUILDING_DESKTOP_BASE_QUERY_URL_CONFIG_KEY =
  'newbuilding-promos-frontend.newbuildingListing.desktopBaseQueryUrl';
export const NEWBUILDING_MOBILE_BASE_QUERY_URL_CONFIG_KEY =
  'newbuilding-promos-frontend.newbuildingListing.mobileBaseQueryUrl';
export const OFFERS_BASE_QUERY_URL_CONFIG_KEY = 'newbuilding-promos-frontend.offersListing.baseQueryUrl';

export const DEFAULT_REGIONS_CONFIG_KEY = 'newbuilding-promos-frontend.regions.default';

export const UNIQUE_PROMO_ID_QUERY_PARAM_CONFIG_KEY = 'newbuilding-promos-frontend.uniquePromoIdQueryParam';
